import {styled} from "@mui/material";

export const BackgroundContainer = styled('img')(() => {
    return {
        minHeight: '100%',
        minWidth: '100%',
        position: 'fixed',
        overflow: 'hidden',
        opacity: 0,
        transition: 'all 2s ease',
        bottom: 0,
        zIndex: -1,
        backgroundColor: '#F1F1FB'
    }
});
